//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props:['vehicleSlug', 'show'],
    mounted(){
        let user = this.$store.state.auth.user
        // console.log(user)
        if(user){
            this.form.name = user.name
            if(user.whatsapp){
                this.form.contact = user.whatsapp
            }else{
                this.form.contact = user.email
            }
        }
    },
    data(){
        return{
            form: {
                name: '',
                contact: '',
                message: 'Hola. ¿Sigue disponible?'
            },
            send: false,
            sending: false,
            errors: {}
        }
    },
    methods:{
        submit(){
            this.sending = true
            this.$axios.post(`email/vehicle/${this.vehicleSlug}`, this.form)
                .then(res => {
                    // console.log(res)
                    window.scrollTo(0, 0)
                    this.send = true
                    this.form = {
                        name: '',
                        contact: '',
                        message: 'Hola. ¿Sigue disponible?'
                    }
                })
                .catch(err => {
                    this.errors = {}
                    if(err.response.data.errors){
                        // console.log(err.response.data)
                        window.scrollTo(0, 0)
                        this.errors = err.response.data.errors
                    }else{
                        // console.log(err.response)
                        console.error(err)
                    }
                })
                .finally(() => {
                    this.sending = false
                })
        }
    }
}
